import pageheader from "./pageheader.module.css"
import { Outlet } from "react-router-dom"
import { Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"


export const PageHeader = () => {
    const cart = useSelector(state => state.cart)
    let itemsinCart = 0
    for (let key of cart){
        if (key.quantity > 0){
        itemsinCart += key.quantity
  }
}
    return (
        <>
        <div className={pageheader.headerContainer}>

            <img width="32" height="32" src="https://img.icons8.com/ios/32/search--v1.png" alt="search--v1"/>
            <Link to="/" className={pageheader.homeLink}>
            <h1>Faizify</h1>
            </Link>
            <Link to="/cart" className={pageheader.cartIcon}>
            <img width="32" height="32" src="https://img.icons8.com/fluency-systems-regular/32/shopping-bag--v1.png" alt="shopping-bag--v1"/>
            {itemsinCart >= 1 ? (<div className={pageheader.cartCount}>{itemsinCart}</div>) : ""}
            </Link>
            
            
        </div>
        <Outlet/>
        </>
    
    )
}